import { Grid2 as Grid } from "@mui/material";
import { SearchBarContainer } from "./SearchBar/SearchBarContainer";
import { SearchResultMessage } from "./SearchResultsMessage/SearchResultMessage";
import { HandleCheckinDialogOpenAsyncProps, OnSearchResultSelectAsyncProps, SearchResultItem } from "../types";
import { purchaseOrderStatus } from "../../../util/purchaseOrderStatus";
import TransferCard from "../../Transfer/TransferCard/TransferCard";
import { PurchaseOrderSearchResultCard } from "./SearchResultCard/PurchaseOrderSearchResultCard";
import { receiveStatus } from "../../../util/receiveStatus";

type SearchProps = {
	helperText: string;
	searchText: string;
	searchResults: Array<SearchResultItem>;
	userLocation: number;
	handleSearch: (value: string) => Promise<void> | void;
	onSearchResultSelectAsync: OnSearchResultSelectAsyncProps;
	onDisabledSearchResultSelectAsync: () => void;
	handleCheckinDialogOpenAsync: HandleCheckinDialogOpenAsyncProps;
	onReopenPoClick: (purchaseOrderNumber: string) => Promise<void>;
};
export const SearchContainer = ({
	helperText,
	searchText,
	searchResults,
	userLocation,
	handleSearch,
	onSearchResultSelectAsync,
	onDisabledSearchResultSelectAsync,
	handleCheckinDialogOpenAsync,
	onReopenPoClick,
}: SearchProps) => {
	return (
		<>
			<SearchBarContainer helperText={helperText} handleSearch={handleSearch} />
			{searchText && searchResults.length >= 0 && <SearchResultMessage searchResultFound={searchResults.length} />}
			<Grid container direction="column" spacing={2} wrap={"nowrap"}>
				{searchResults.map((sr, i) => {
					const { purchaseOrder, transfer, invoices, receive } = sr;
					if (purchaseOrder && purchaseOrder.purchaseOrderNumber) {
						return (
							<Grid key={`${purchaseOrder.purchaseOrderNumber}_${i}`}>
								<PurchaseOrderSearchResultCard
									searchDataSource={sr.searchDataSource}
									purchaseOrder={purchaseOrder}
									invoices={sr.invoices || []}
									highlightInvoice={sr.highlightInvoice}
									onSelect={onSearchResultSelectAsync}
									onDisabledSelect={onDisabledSearchResultSelectAsync}
									userLocation={userLocation}
									onOpenCheckin={() =>
										handleCheckinDialogOpenAsync(purchaseOrder.purchaseOrderNumber, invoices?.[0]?.invoiceNumber || "")
									}
									actions={[
										{
											function: () => onReopenPoClick(purchaseOrder.purchaseOrderNumber),
											displayName: "Reopen PO",
										},
									]}
									isShowActionMenuInHeader={purchaseOrder.status === purchaseOrderStatus.cancelled}
								/>
							</Grid>
						);
					} else if (transfer && transfer.sourceId) {
						return (
							<Grid key={`${transfer.id}`}>
								<TransferCard
									receiveStatus={receive?.receiveStatus || receiveStatus.open}
									displayMode="SearchResult"
									transfer={transfer}
								/>
							</Grid>
						);
					}
					return null;
				})}
			</Grid>
		</>
	);
};
